import { createFileRoute } from "@tanstack/react-router";

import { NewThreadLanding } from "../components/newThread/NewThreadLanding";

export const Route = createFileRoute("/_chat/new")({
  component: NewThreadRouteView,
  // `project`/`execution` let a caller (e.g. the sidebar's "+" on a
  // not-yet-connected cloud project) preselect a project on this landing page
  // instead of provisioning it directly. See preConnectCloudNewThreadRoute.ts.
  validateSearch: (search: Record<string, unknown>): { project?: string; execution?: string } => {
    const project = search["project"];
    const execution = search["execution"];
    return {
      ...(typeof project === "string" ? { project } : {}),
      ...(typeof execution === "string" ? { execution } : {}),
    };
  },
});

function NewThreadRouteView() {
  return <NewThreadLanding />;
}
